import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import {
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Grid,
    Button,
    Chip,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    CircularProgress,
} from "@material-ui/core";
import moment from "moment";

import "./GigPromotionCard.css";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";

const style = {
    promotionStatus: {
        minWidth: 50,
        color: "#ffffff",
        fontWeight: 600,
        fontSize: "12px"
    },
    status: {
        draft: {
            backgroundColor: "#757575"
        },
        pending: {
            backgroundColor: "#ff0c9c"
        },
        published: {
            backgroundColor: "#43a047"
        },
        completed: {
            backgroundColor: "#bdbdbd"
        }
    },
    promotionImage: {
        paddingTop: "56.25%",
        width: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center top"
    }
};

@withRouter
@inject("gigPromotionStore", "templateStore")
@observer
class GigPromotionCard extends Component {

    constructor(props){
        super(props);
        this.state = {
            cancelModalState: false,
            endTimeDialogOpen: false,
            endTimeValue: "",
            endTimeSaving: false,
            endTimeError: "",
        }
    }

    openCancelModal = () => this.setState({ ...this.state, cancelModalState: true });
    closeCancelModal = () => this.setState({ ...this.state, cancelModalState: false });

    openEndTimeDialog = () => {
        this.setState({
            endTimeDialogOpen: true,
            endTimeValue: "",
            endTimeError: "",
        });
    };

    closeEndTimeDialog = () => {
        if (this.state.endTimeSaving) return;
        this.setState({ endTimeDialogOpen: false, endTimeError: "" });
    };

    handleEndTimeChange = (e) => {
        this.setState({ endTimeValue: e.target.value, endTimeError: "" });
    };

    handleSaveEndTime = () => {
        const { endTimeValue } = this.state;
        const { gigPromotion, gigPromotionStore } = this.props;
        if (!endTimeValue) {
            this.setState({ endTimeError: "Please select an end time." });
            return;
        }
        this.setState({ endTimeSaving: true, endTimeError: "" });
        gigPromotionStore.patchGigPromotionTimeEnd(gigPromotion, endTimeValue).then(() => {
            this.setState({ endTimeSaving: false, endTimeDialogOpen: false });
        }).catch(() => {
            this.setState({ endTimeSaving: false, endTimeError: "Failed to save. Please try again." });
        });
    };

    getPromotionStatus = promotion => {
        if (moment().endOf("day") > moment(promotion.dateStart).endOf("day") && promotion.published) {
            return "Completed";
        } else if (promotion.published) {
            return "Published";
        } else if (promotion.isDraft) {
            return "Draft";
        } else {
            return "Pending";
        }
    };

    getGigPromotionTitle = gigPromotion => {
        if (gigPromotion.title) {
            return gigPromotion.title;
        } else {
            return `${gigPromotion.actName ? gigPromotion.actName : ""}@${gigPromotion?.venue?.profileName ? gigPromotion.venue.profileName : ""}`;
        }
    }

    getGigPromotionDateTimeParts = gigPromotion => {
        const date = new Date(gigPromotion.dateStart);
        let date_utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        var timeStart = moment(gigPromotion.timeStart, "HH:mm").format('hh:mm A');
        var timeEndMoment = moment(gigPromotion.timeEnd, "HH:mm");
        var timeEndValid = timeEndMoment.isValid();
        var timeEnd = timeEndValid ? timeEndMoment.format('hh:mm A') : null;
        return {
            dateStr: moment(date_utc).format('DD-MM-YYYY'),
            timeStart,
            timeEnd,
            timeEndValid,
        };
    }

    handleEditGigPromotion = () => {
        const { gigPromotion } = this.props;
        this.props.templateStore.history.push(`/gig/promotion/${gigPromotion.id}/edit`);
    };

    handleCancelGigPromotion = () => {
        this.props.cancelGigPromotionHandler();
        this.closeCancelModal();
    }

    render() {
        const { gigPromotion, hideActionsButton } = this.props;
        const { cancelModalState, endTimeDialogOpen, endTimeValue, endTimeSaving, endTimeError } = this.state;
        const status = gigPromotion ? this.getPromotionStatus(gigPromotion) : null;

        let dateParts = null;
        if (gigPromotion) {
            dateParts = this.getGigPromotionDateTimeParts(gigPromotion);
        }

        return gigPromotion ? (
            <Fragment>
                <Card className="gig-promotion-card">
                    <CardMedia
                        image={gigPromotion.imageUrl}
                        style={style.promotionImage}
                        className="gig-promotion-card-media"
                    />
                    <CardContent className="gig-promotion-card-content">
                        <div className="gig-promotion-card-header">
                            <Typography variant="subtitle1" className="gig-promotion-card-title">
                                {this.getGigPromotionTitle(gigPromotion)}
                            </Typography>
                            <Chip
                                label={status}
                                style={{ ...style.promotionStatus, ...style.status[status.toLowerCase()] }}
                                className="gig-promotion-status-chip"
                            />
                        </div>
                        <Typography variant="caption" className="gig-promotion-card-date" component="div">
                            {dateParts.dateStr} / {dateParts.timeStart} -{" "}
                            {dateParts.timeEndValid ? (
                                dateParts.timeEnd
                            ) : (
                                <span
                                    onClick={this.openEndTimeDialog}
                                    style={{
                                        color: "#ff0c9c",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        fontWeight: 600,
                                    }}
                                    title="Click to add end time"
                                >
                                    Add end time
                                </span>
                            )}
                        </Typography>
                        <Grid container style={{ marginTop: 8 }}>
                            <Grid item xs={6}>
                                <Typography variant="caption" className="gig-promotion-card-meta">
                                    <i className="fa fa-building" style={{ marginRight: 4 }} />
                                    {gigPromotion.venue?.profileName}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="caption" className="gig-promotion-card-meta">
                                    <i className="mh-band" style={{ marginRight: 4 }} />
                                    {gigPromotion.actName}
                                </Typography>
                            </Grid>
                            {gigPromotion.ticketPrice !== null && gigPromotion.ticketPrice !== undefined && gigPromotion.ticketPrice !== "" ? (
                                <Grid item xs={12}>
                                    <Typography variant="caption" className="gig-promotion-card-meta" style={{ display: "block", marginTop: 4 }}>
                                        <i className="fa fa-ticket" style={{ marginRight: 4 }} />
                                        {`Tickets from $${Number(gigPromotion.ticketPrice).toFixed(2)}`}
                                    </Typography>
                                </Grid>
                            ) : null}
                            <Grid item xs={12}>
                                <div className="gig-promotion-card-description">
                                    <Typography variant="caption" className="gig-promotion-card-meta" style={{ display: "block", marginBottom: 4 }}>
                                        About Act:
                                    </Typography>
                                    <div
                                        className="gig-promotion-card-about"
                                        dangerouslySetInnerHTML={{ __html: gigPromotion.actDescription }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {!hideActionsButton ? (
                        <CardActions className="gig-promotion-card-actions">
                            <Button
                                variant="contained"
                                size="small"
                                onClick={this.handleEditGigPromotion}
                                style={{ backgroundColor: "#ff0c9c", color: "#fff", textTransform: "none", boxShadow: "none" }}
                            >
                                Edit
                            </Button>
                            <Button
                                variant="outlined"
                                className="btn-outline"
                                onClick={this.openCancelModal}
                                size="small"
                            >
                                Cancel
                            </Button>
                        </CardActions>
                    ) : null}
                </Card>
                <ConfirmationModal
                    open={cancelModalState}
                    title="Gig Promotion Warning"
                    closeHandler={this.closeCancelModal}
                    message="Are you sure to cancel this gig promotion?"
                    confirmationLabel="Cancel"
                    confirmationHandler={this.handleCancelGigPromotion}
                />
                <Dialog open={endTimeDialogOpen} onClose={this.closeEndTimeDialog} maxWidth="xs" fullWidth>
                    <DialogTitle>Add End Time</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="End Time"
                            type="time"
                            value={endTimeValue}
                            onChange={this.handleEndTimeChange}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ step: 300 }}
                            fullWidth
                            disabled={endTimeSaving}
                            error={!!endTimeError}
                            helperText={endTimeError}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeEndTimeDialog} disabled={endTimeSaving}>
                            Cancel
                        </Button>
                        <Button
                            onClick={this.handleSaveEndTime}
                            color="primary"
                            variant="contained"
                            disabled={endTimeSaving}
                            style={{ backgroundColor: "#ff0c9c", color: "#fff", boxShadow: "none" }}
                        >
                            {endTimeSaving ? <CircularProgress size={18} style={{ color: "#fff" }} /> : "Save"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        ) : null;
    }
}

export default GigPromotionCard;
